export const ID_EN_CURSO = 1;
export const ID_APROBADO = 2;
export const ID_RECHAZADO = 3;

// Estados con los que la grilla "Seguimiento de secuencias" muestra y filtra un intento. DESCALIFICADO: rechazado y sin intentos disponibles.
export const GRILLA_EN_CURSO = 'EN_CURSO';
export const GRILLA_RECHAZADO = 'RECHAZADO';
export const GRILLA_APROBADO = 'APROBADO';
export const GRILLA_DESCALIFICADO = 'DESCALIFICADO';

// Estado de cada checklist dentro del intento.
export const CHECKLIST_PENDIENTE = 'PENDIENTE';
export const CHECKLIST_APROBADO = 'APROBADO';
export const CHECKLIST_RECHAZADO = 'RECHAZADO';
// Desaprobado por el operador, a la espera de la decisión del supervisor (validación granular).
export const CHECKLIST_EN_VALIDACION = 'EN_VALIDACION';
